import React from "react";
import PropTypes from "prop-types";
import { path } from "ramda";
import { Modal, Form, Input, Row, Col, Button, Pagination } from "antd";
import I18n from "../../i18n";
import ContentBox from "../../components/layout/ContentBox";
import { AdminTransfer } from "../../components/form/AdminTransfer";
import { isAlive, isFunction, ArrayUtil } from "../../util/index";
import Store from "../../reducers";
import StepCounter from "../../util/helper/StepCounter";
import { addAdmins, deleteAdmins, fetchAdmin } from "../../actions/OrganizationAction";
import OrganizationActions from "../../reducers/OrganizationReducer";
import { ContainerLoading } from "../../components/loading/PersistGateLoading";
import { Roles } from "../../util/organize";
import { InlineDiv } from "../../components/layout/Layout";
import { Metrics } from "../../theme";
import OForm from "../../components/form/OForm";
import { ColumnLabel } from "../../components/text/OText";
import ModalUtil from "../../util/modal";

const FormItem = Form.Item;
class AdminSettingPanel extends React.Component{
    tranfer = undefined;
    state = {
    	isLoading: false,
    	admins:[],
    	employees:[],
    	employeeTotal: 40,
    	page: 1,
    	per_page: 10,
    	search: "",
    }
    texts = {}
    constructor(props){
    	super(props);
    	const { admins, employees, getActiveEmp } = props;
    	this.state = {
    		isLoading: false,
    		admins,
    		employees,
    		employeeTotal: 40,
    		page: 1,
    		per_page: 10,
    		search: ""
    	};
    	this.texts = {
    		search_email_label: I18n.t("search_placeholder.email"),
    		search_email_placeholder:I18n.t("search_placeholder.email"),
    		search_submit:I18n.t("search"),
    		search_clear:I18n.t("clear"),
    	};
    }
    componentDidMount(){
    	this.refreshEmployee();
    }
    componentWillReceiveProps(props){
    	const { admins } = props;
    	this.setState({admins});
    }
    createQueryOption = (search="")=>{
    	const { page, per_page } = this.state;
    	const options = { 
    		page, per_page, 
    		active:"active", 
    		exclude:"admin" 
    	};
    	if(isAlive(search) && search != ""){
    		options["search"] = search;
    	}
    	return options;
    }
    refreshEmployee(search = ""){
    	const { getActiveEmp } = this.props;
    	getActiveEmp(this.createQueryOption(search))
    		.then(this.onGetEmployee)
    		.catch(ModalUtil.showError);
    }
    onGetEmployee = (res)=>{
    	if(isAlive(res.employees)){
    		this.setState({
    			isLoading:false, 
    			employeeTotal:path(["pagination","total"],res),
    			employees:res.employees
    		});
    	}
    }
    toDataSource(user_id, email, index, disabled = false){
    	return {
    		key: index,
    		user_id: user_id,
    		title: email,
    		description: email,
    		disabled: disabled,
    	};
    }
    onSubmitTransfer(){
    	const { getActiveEmp } = this.props;
    	const { toAdmin, toUser } = this.tranfer.getTargetValues();
    	let count = (toAdmin.length > 0 ? 1 : 0) + (toUser.length > 0 ? 1 : 0);
    	const counter = new StepCounter(()=>{
    		fetchAdmin().then(()=>{
    			this.refreshEmployee(this.getSearchString());
    			// this.setState({isLoading: false});
    		}).catch(error=>{
    			// console.error('fetchAdmin error: ',error);
    			this.setState({isLoading: false});
    		});
    	});
    	if(toAdmin.length > 0){
    		counter.addTarget((callback)=>{
    			addAdmins(Array.from(toAdmin, v=>v.title), false).then(callback);
    		});
    	}
    	if(toUser.length > 0){
    		counter.addTarget((callback)=>{
    			deleteAdmins(Array.from(toUser, v=>v.user_id),false).then(callback);
    		});
    	}
    	if(counter.count() > 0){
    		this.setState({isLoading: true});
    	}
    	counter.start(false);
    }
    getSelectableMembers(members, admins, selectedUserIDs){
    	// Filter out super admin and create member as dataSource format
    	const nonSuperadmin = Array.from(admins, (e,i)=>this.toDataSource(e.id, e.email,i));
    	// Transform member data to Transfer data.
    	const memberDataSource = Array.from(members,(e,i)=>this.toDataSource(e.user_id, e.email, i));
    	// Combine admin and member then reindex(key) of each item.
    	return Array.from(nonSuperadmin.concat(memberDataSource),(item,index)=>({...item, key:index}));
    }
    genrateTransferData(allAdmins = [], employees = []){
    	// Get admin that is not be OrganizationSuperAdmin.
    	const organizeAdmin = allAdmins.filter(e=>
    		e.roles.indexOf(Roles.OrganizationAdmin)!==-1 &&
            e.roles.indexOf(Roles.OrganizationSuperAdmin) === -1
    	);
    	const selectKeys = Array.from(organizeAdmin,(e,i)=>this.toDataSource(e.id,e.email,i));
    	const selectableMember = this.getSelectableMembers(employees, organizeAdmin);
    	return { selectKeys, selectableMember };
    }
    handleSearch = (e)=>{
    	e.preventDefault();
    	this.props.form.validateFields((err, values) => {
    		if(!ArrayUtil.isAliveArray(err)){
    			const { getActiveEmp } = this.props;
    			this.setState({isLoading:true});
    			getActiveEmp(this.createQueryOption(values["search"]))
    				.then(this.onGetEmployee).catch(ModalUtil.showError);
    		}
    	});
    }
    getSearchString(){
    	return this.props.form.getFieldValue("search");
    }
    clearSearch = ()=>{
    	this.setState({search:""});
    }
    onPageChanged = (page, per_page)=>{
    	this.setState({page, per_page},()=>{
    		this.refreshEmployee(this.getSearchString());
    	});
    }
    onShowSizeChange = (page, per_page)=>{
    	this.setState({page, per_page},()=>{
    		this.refreshEmployee(this.getSearchString());
    	});
    }
    render(){
    	const { admins = [], form:{getFieldDecorator} } = this.props;
    	const { employees = [], employeeTotal, page, per_page } = this.state;
    	const { selectKeys, selectableMember } = this.genrateTransferData(admins.slice(), employees);
    	return (<ContentBox.Box>
    		<ContainerLoading tip={I18n.t("loadings.apply_change")} isLoading={this.state.isLoading}>
    			<ContentBox.HeaderToolbar 
    				header={I18n.t("admin_setting")} 
    				buttonsProps={[
    					{ text:I18n.t("submit"), onClick: this.onSubmitTransfer.bind(this) }
    				]}
    			/>
    			<Form onSubmit={this.handleSearch}>
    				<InlineDiv middle fullWidth style={{marginBottom:Metrics.button.spaceMargin}}>
    					<ColumnLabel style={{
    						minWidth:100,
    						marginRight: Metrics.button.spaceMargin, 
    					}}>{this.texts.search_email_label}</ColumnLabel>
    					{getFieldDecorator("search")(<Input 
    						style={{marginRight:Metrics.button.spaceMargin}} 
    						placeholder={this.search_email_placeholder} 
    					/>)}
    					<Button type="primary" htmlType='submit' >{this.texts.search_submit}</Button>
    					<Button style={{ marginLeft: 8 }} onClick={this.clearSearch}>
    						{this.texts.search_clear}
    					</Button>
    				</InlineDiv>
    			</Form>
    			<AdminTransfer 
    				setRef = {ref=>{this.tranfer = ref;}}
    				members={selectableMember}
    				admins={selectKeys}
    				render={item=>item.title}
    				maxAdmin={3}
    				footer={<Pagination style={{marginTop:Metrics.button.bigSpaceMargin}} 
    					onChange={this.onPageChanged} 
    					onShowSizeChange={this.onShowSizeChange}
    					size="small" 
    					current={page}
    					pageSize={per_page}
    					total={employeeTotal} 
    					showSizeChanger />
    				}
    			/>
                    
    		</ContainerLoading>
    	</ContentBox.Box>);
    }
}
AdminSettingPanel.defaultProps = {
	getActiveEmp: null,
	admins: [],
	employees:[],
};
AdminSettingPanel.propTypes = {
	getActiveEmp:PropTypes.func.isRequired,
	admins: PropTypes.array.isRequired,
	employees: PropTypes.array.isRequired,
};
export default Form.create()(AdminSettingPanel);


// WEBPACK FOOTER //
// ./src/containers/AccountPanels/AdminSettingPanel.js